module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
    }
  }, [_c('div', {
    staticClass: "olst-field-selection band-size"
  }, [_c('label-component', {
    staticClass: "olst-field-label olst-field-label-a-b",
    attrs: {
      "name": _vm.fieldRef,
      "text": ""
    }
  }), _c('select-with-picture-component', {
    attrs: {
      "name": _vm.fieldRef,
      "options": _vm.injectPictureInOption,
      "defaultField": _vm.cc_value,
      "disabled": _vm.isFieldDisable()
    },
    on: {
      "value-changed": _vm.fieldChanged
    }
  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
    return (_vm.isValidationMessage(key)) ? _c('div', {
      staticClass: "olst-field-validation-picture-field-alt"
    }, _vm._l((messages), function(message) {
      return _c('div', {
        class: {
          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
        }
      }, [_c('text-component', {
        attrs: {
          "text": _vm.__t(message)
        }
      })], 1)
    })) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f27dd14!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_unit/abTest/SelectionPictureBandeSize.vue
// module id = 334
// module chunks = 1